import { parseIncomingCallPayload } from '../../infrastructure/adapters/voiceSocketEventAdapter';
import { voiceAddIncomingCall, voiceSetError, voiceSetRinging } from '../../../../../actions/voice/voiceActions';
import { connectAgentWebRtcClient, discardDeadAgentCall } from '../../infrastructure/webrtc/voiceAgentWebRtcAdapter';
import { getVoiceTabClaimedCallControlId } from '../voiceHangupCoordinator';
import { voiceSocketLog } from '../../../../utils/voiceSocketDebug';

export default function incomingCallHandler(payload, ports) {
  const parsed = parseIncomingCallPayload(payload);
  if (!parsed) {
    voiceSocketLog('incoming_call ignored (invalid payload)', payload);
    ports.dispatch(voiceSetError('Invalid incoming_call payload'));
    return;
  }

  const { incomingCalls, activeCall } = ports.getHandlerState();
  const duplicateSession = parsed.callSessionId
    && incomingCalls.some((call) => call.callSessionId === parsed.callSessionId);
  if (duplicateSession) {
    voiceSocketLog('incoming_call ignored (duplicate session)', parsed.callControlId);
    return;
  }

  voiceSocketLog('dispatch incoming_call', parsed.callControlId);
  if (!activeCall && !getVoiceTabClaimedCallControlId()) {
    discardDeadAgentCall();
  }
  ports.dispatch(voiceAddIncomingCall(parsed));
  ports.dispatch(voiceSetRinging(true));
  connectAgentWebRtcClient().catch((error) => {
    voiceSocketLog('incoming_call webrtc connect failed', {
      message: error instanceof Error ? error.message : String(error)
    });
  });
}
